<template>
  <div>
    <el-dialog :visible.sync="isShowActiveAccount" @close="close" :show-close="false" append-to-body center
      class="width550">
      <div class="dialog-content">
        <div class="loginBox-left"></div>
        <div class="loginBox-right">
          <el-form ref="form" :model="form" :rules="rules">
            <ul class="loginForm auto relative zIndex2">
              <li v-if="codeLoginFlag == 0 || codeLoginFlag == 1" class="cen flex size18 C777 line10 end mb30">
                <div class="Conhover mr50 pointer" :class="{ active: type == 0 }"
                  @click="(type = 0), (codeLoginFlag = 0)">
                  登录
                </div>
                <div class="pointer Conhover" :class="{ active: type == 1 }" @click="(type = 1), (codeLoginFlag = 1)">
                  注册
                </div>
              </li>
              <li v-if="codeLoginFlag == 2" class="cen flex size18 C777 line10 end mb30">
                <div class="Conhover pointer actives">密码重设</div>
              </li>
              <el-form-item prop="userName" v-if="codeLoginFlag == 0">
                <el-input placeholder="请输入您的注册手机号" v-model="form.userName">
                  <div slot="prefix" class="ml5 mt3">
                    <img src="@/assets/img/2.png" alt="" />
                  </div>
                </el-input>
              </el-form-item>
              <el-form-item prop="password" v-if="codeLoginFlag == 0">
                <el-input placeholder="请输入密码" v-model="form.password" show-password>
                  <div slot="prefix" class="ml5 mt3">
                    <img src="@/assets/img/1.png" alt="" />
                  </div>
                </el-input>
              </el-form-item>
              <el-form-item prop="valiCode" v-if="codeLoginFlag == 0">
                <li class="flex nowrap">
                  <el-input class="flex2 mr15" placeholder="图片验证码" v-model="form.valiCode">
                    <div slot="prefix" class="ml5 mt3">
                      <img src="@/assets/img/3.png" alt="" />
                    </div>
                  </el-input>
                  <identify ref="identify" :height="49" :width="115" class="identify" />
                </li>
              </el-form-item>
              <el-form-item prop="userPhone" v-if="codeLoginFlag == 1 || codeLoginFlag == 2">
                <el-input placeholder="请输入您的注册手机号" v-model="form.userPhone">
                  <div slot="prefix" class="ml5 mt3">
                    <img src="@/assets/img/2.png" alt="" />
                  </div>
                </el-input>
              </el-form-item>
              <el-form-item prop="dXCode" v-if="codeLoginFlag == 1 || codeLoginFlag == 2">
                <li class="flex nowrap liBd">
                  <el-input class="flex2 mr15 noBd" placeholder="请输入验证码" v-model="form.dXCode">
                    <div slot="prefix" class="ml5 mt3">
                      <img src="@/assets/img/3.png" alt="" />
                    </div>
                  </el-input>

                  <div style="
                      border-radius: 4px;
                      overflow: hidden;
                      height: 50px;
                      width: 120px;
                      cursor: pointer;
                    ">
                    <p @click="handleCode" v-if="time1 == 60" style="
                        height: 100%;
                        border: 0;
                        width: 100%;
                        white-space: nowrap;
                        border-radius: 5px;
                        display: flex;
                        color: #1d79ff;
                        align-items: center;
                        justify-content: center;
                      ">
                      获取短信验证码
                    </p>

                    <p v-else style="
                        height: 100%;
                        border: 0;
                        width: 100%;
                        border-radius: 5px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      ">
                      {{ time1 }}s 后获取
                    </p>
                  </div>
                  <!-- <identify
              ref="identify"
              :height="49"
              :width="160"
              style="border-radius: 4px; overflow: hidden"
            /> -->
                </li>
              </el-form-item>
              <el-form-item v-if="codeLoginFlag == 1 || codeLoginFlag == 2" prop="passWord">
                <el-input placeholder="请设置您的登录密码" v-model="form.passWord" show-password>
                  <div slot="prefix" class="ml5 mt3">
                    <img src="@/assets/img/4.png" alt="" />
                  </div>
                </el-input>
              </el-form-item>
              <p v-if="codeLoginFlag == 1 || codeLoginFlag == 2" class="center red mb10">
                8-20位密码，必须包含字母、数字、特殊符号
              </p>
              <el-form-item v-if="codeLoginFlag == 1 || codeLoginFlag == 2" prop="passWord2">
                <el-input placeholder="请再次输入您设置的登录密码" v-model="form.passWord2" show-password>
                  <div slot="prefix" class="ml5 mt3">
                    <img src="@/assets/img/4.png" alt="" />
                  </div>
                </el-input>
              </el-form-item>
              <li v-if="codeLoginFlag == 1" class="flex nowrap start agreement">
                <el-checkbox v-model="checked" class="tongyi"></el-checkbox>
                <div class="ml10 line24">
                  阅读并同意<a class="underline" @click="toAgreement">《用户协议》</a>
                </div>
              </li>
              <li v-if="codeLoginFlag == 0" class="flex nowrap start agreement">
                <el-checkbox v-model="flagNoPass"></el-checkbox>
                <div class="ml10 line24">记住密码</div>
              </li>
              <!--新增开始结束  -->
              <el-button v-if="codeLoginFlag == 0" type="primary" class="width100 size16 mt20 subbtn" @click="submit(0)"
                v-loading="isLoading">登录</el-button>
              <el-button v-if="codeLoginFlag == 1" type="primary" class="width100 size16 mt20 subbtn" @click="submit(1)"
                v-loading="isLoading">注册</el-button>
              <el-button v-if="codeLoginFlag == 2" type="primary" class="width100 size16 subbtn" @click="submit(2)"
                v-loading="isLoading">重置密码</el-button>
            </ul>
            <div v-if="codeLoginFlag == 0" class="forget" @click="codeLoginFlag = 2">
              忘记密码
            </div>
            <div v-if="codeLoginFlag == 2">
              <div class="xianBox">
                <span @click="(type = 0), (codeLoginFlag = 0)">登录账号</span>
                <div class="xian"></div>
                <span @click="(type = 1), (codeLoginFlag = 1)">注册账号</span>
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </el-dialog>

    <el-dialog class="loginDialog" title="筑才用户服务协议" :visible.sync="agreementDialog" width="500px"
      :append-to-body="true">
      <div class="scroll BGwhite pad20 line35 C222 b500 radius8 size16 vh10">
        <div v-html="$store.state.ServiceAgreement"></div>
        <el-empty class="width50 auto" :image="empty1" v-if="!$store.state.ServiceAgreement" />
      </div>
      <span slot="footer" class="flex cen">
        <el-button type="primary" @click="
          agreementDialog = false;
        checked = true;
        ">我已阅读，并同意以上条款</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getToken, setToken, removeToken } from "@/util/auth";
import identify from "./identify.vue";
import { SendSMS, GetLabelContent } from "@/api/common";
import { Login, Register, ForgotPassword } from "@/api/login";
const Base64 = require("js-base64").Base64;
export default {
  props: {
    isShowActiveAccount: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    identify,
  },
  data() {
    const validator = (rule, value, callback) => {
      console.log(value);

      if (value.trim().length === 0) {
        callback(new Error("图片验证码不能为空"));
      } else if (value !== this.$refs.identify.identifyCode) {
        callback(new Error("图片验证码不正确"));
      } else {
        callback();
      }
    };
    const validator1 = (rule, value, callback) => {
      if (value.trim().length === 0) {
        callback(new Error("确认密码不能为空"));
      } else if (value !== this.form.passWord) {
        callback(new Error("2次密码不一致"));
      } else {
        callback();
      }
    };
    return {
      agreementDialog: false,
      checked: false,
      type: 0,
      codeLoginFlag: 0, // 0登录 1注册 2忘记密码
      flagNoPass: false,
      timer: null,
      time1: 60,
      form: {
        userName: "", // 17816121263
        password: "", // Dy123456
        valiCode: "",
        dXCode: "",
        userPhone: "",
        passWord: "",
        passWord2: "",
      },
      rules: {
        userName: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        userPhone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        dXCode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        valiCode: [{ validator, trigger: "blur" }],
        // dXCode: [{ validator1, trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        passWord: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 8,
            max: 16,
            required: true,
            message: "长度8～16个字符",
            trigger: "blur",
          },
          {
            pattern: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[^\w\s]).+$/,
            message: "密码需包含字母、数字、特殊符号",
          },
        ],
        passWord2: [
          { required: true, message: "请确认密码", trigger: "blur" },
          { validator: validator1, trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    type() {
      this.$refs.identify.drawPic();
    },
    codeLoginFlag() {
      this.$refs.form.clearValidate();
    },
    isShowActiveAccount(val) {
      if (val) {
        const username = localStorage.getItem("user_userId");
        if (username) {
          this.form.userName = localStorage.getItem("user_userId");
          this.form.password = Base64.decode(localStorage.getItem("user_password")); // base64解密
          this.flagNoPass = true;
        }
      }
    },
  },
  mounted() {
    if (!this.$store.state.ServiceAgreement) {
      GetLabelContent({ code: "agreement" }).then(({ data }) => {
        this.$store.state.ServiceAgreement = data.Body;
      });
    }
  },
  methods: {
    toAgreement() {
      this.toUrl("/agreement");
    },
    close(flag) {
      this.type = 0;
      this.codeLoginFlag = 0;
      this.checked = false;
      this.$refs.form.resetFields();
      this.$emit("closePop", flag);
    },
    handleCode() {
      if (!this.form.userPhone) {
        return this.$message({ message: "请输入手机号", type: "warning" });
      }
      const TypeID =
        this.codeLoginFlag === 1 ? 2 : this.codeLoginFlag === 2 ? 3 : "";
      SendSMS({ Phone: this.form.userPhone, TypeID })
        .then((res) => {
          if (res.code === 0) {
            this.$message({ message: "发送成功", type: "success" });
            this.daojishi();
          } else {
            // this.$message({ message: res.msg, type: "warning" });
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    daojishi() {
      this.timer = setInterval(() => {
        if (this.time1 <= 0) {
          this.time1 = 60;
          clearInterval(this.timer);
        } else {
          this.time1 = Number(this.time1) - 1;
        }
      }, 1000);
    },
    submit(type) {
      // 0登录 1注册 2忘记密码
      if (this.isLoading) {
        return;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.checked && this.codeLoginFlag === 1) {
            return this.$message({ message: "请先同意协议", type: "warning" });
          }
          let fcn = Login;
          let data = {};
          if (type === 0) {
            if (this.flagNoPass === true) {
              const pass = Base64.encode(this.form.password); // base64加密
              localStorage.setItem("user_userId", this.form.userName);
              localStorage.setItem("user_password", pass);
            } else {
              localStorage.removeItem("user_userId");
              localStorage.removeItem("user_password");
            }

            data = {
              Phone: this.form.userName,
              Password: this.form.password,
              IsRemeber: this.flagNoPass,
            };
          } else if (type === 1) {
            fcn = Register;
            data = {
              Phone: this.form.userPhone,
              SmsCode: this.form.dXCode,
              Password: this.form.passWord,
              ConfirmPassword: this.form.passWord2,
            };
          } else if (type === 2) {
            fcn = ForgotPassword;
            data = {
              Phone: this.form.userPhone,
              SmsCode: this.form.dXCode,
              Password: this.form.passWord,
              ConfirmPassword: this.form.passWord2,
            };
          }
          this.isLoading = true;
          fcn(data)
            .then((res) => {
              this.isLoading = false;
              if (res.code === 0) {
                this.$message.success("操作成功");
                if (this.codeLoginFlag === 2) {
                  this.codeLoginFlag = 0;
                  this.type = 0;
                  return false;
                }
                setToken(res.data.Token);
                this.close(true);
                window.location.reload();
              }
            })
            .catch(() => {
              if (this.codeLoginFlag === 0) {
                this.$refs.identify.drawPic();
              }
              this.isLoading = false;
            });
        } else {
          if (this.codeLoginFlag === 0) {
            this.$refs.identify.drawPic();
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.width550 {
  ::v-deep .el-dialog {
    width: 900px;
  }
}

.dialog-content {
  // width: 900px;
  display: flex;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  height: 580px;

  .subbtn {
    width: 340px;
    height: 50px;
    background: #1d79ff;
    border-radius: 6px;
  }

  .identify {
    width: 115px;
    height: 49px;
    overflow: hidden;
    border-radius: 10px;
  }

  .agreement {
    margin-top: -5px;
  }

  ::v-deep .el-checkbox__inner {
    border-radius: 50%;
    zoom: 150%;
  }

  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
  ::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background: #1d79ff;
  }

  ::v-deep .noBd {
    .el-input__inner {
      border: none;
    }
  }

  .underline {
    color: #1d79ff;
    border-bottom: 1px solid #1d79ff;
  }

  .liBd {
    height: 52px;
    padding-right: 5px;
    border-radius: 6px;
    border: 1px solid #dcdfe6;
  }

  .red {
    margin-top: -5px;
    font-size: 14px;
    color: #e25757;
  }

  .forget {
    width: 118px;
    height: 18px;
    font-weight: 400;
    font-size: 18px;
    color: #666666;
    margin: 0 auto;
    margin-top: 100px;
    position: relative;
    cursor: pointer;

    &::after {
      content: "";
      position: absolute;
      width: 10px;
      height: 1px;
      background: #666666;
      top: 13px;
      left: 0;
    }

    &::before {
      content: "";
      position: absolute;
      width: 10px;
      height: 1px;
      background: #666666;
      top: 13px;
      right: 1px;
    }
  }

  .xianBox {
    width: 242px;
    height: 18px;
    font-weight: 400;
    font-size: 18px;
    color: #666666;
    margin: 0 auto;
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: pointer;

    .xian {
      width: 1px;
      height: 18px;
      background: #666666;
      margin: 0 20px;
    }

    &::after {
      content: "";
      position: absolute;
      width: 10px;
      height: 1px;
      background: #666666;
      top: 10px;
      left: 0;
    }

    &::before {
      content: "";
      position: absolute;
      width: 10px;
      height: 1px;
      background: #666666;
      top: 10px;
      right: 1px;
    }
  }

  .loginBox-left {
    width: 370px;
    height: 580px;
    background: url("~@/assets/img/home/36.png") no-repeat;
    background-size: 100% 100%;
  }

  .loginBox-right {
    flex: 1;
    height: 580px;
    text-align: center;

    .Conhover {
      font-size: 26px;
      color: #333333;
      position: relative;
    }

    .active {
      color: #1d79ff;
      font-weight: 500;

      &:after {
        content: "";
        position: absolute;
        width: 24px;
        height: 6px;
        background: #1d79ff;
        border-radius: 3px;
        left: 25%;
        bottom: -10px;
      }
    }

    .actives {
      color: #1d79ff;
      font-weight: 500;

      &:after {
        content: "";
        position: absolute;
        width: 24px;
        height: 6px;
        background: #1d79ff;
        border-radius: 3px;
        left: 38%;
        bottom: -10px;
      }
    }

    .loginForm {
      width: 340px;
      margin: 0 auto;
      margin-top: 50px;

      img {
        width: 22px;
        height: 22px;
      }
    }
  }
}

::v-deep .el-input__inner {
  height: 49px;
  line-height: 49px;
}

::v-deep .el-dialog__header {
  display: none !important;
}

::v-deep .el-dialog__body {
  padding: 0 !important;
}

h3 {
  font-weight: 600;
  font-size: 20px;
  color: #000;
  text-align: center;
  white-space: nowrap;
}

.tipTitle {
  font-weight: 500;
  font-size: 16px;
  color: #000;
  text-align: center;
  white-space: nowrap;
  margin: 15px auto 30px;
}

.input-group {
  margin: 15px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.input-group span {
  color: #000;
  font-size: 14px;
}

.input-group input {
  width: 30%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-left: 20px;
}

.input-group button {
  margin-left: 10px;
  padding: 10px 25px;
  background-color: #bfdcf76f;
  border: 1px solid #1890ff;
  color: #1890ff;
  border-radius: 4px;
  cursor: pointer;
}

.tipTitle2 {
  font-weight: 500;
  font-size: 15px;
  color: #1890ff;
  text-align: center;
  white-space: nowrap;
  margin: 20px auto 40px;
}

.button-group {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 0 20px;
}

.button-group button {
  width: 120px;
  padding: 8px 15px;
  margin-left: 10px;
  border-radius: 4px;
  cursor: pointer;
}

.button-group .cancel {
  background: #f5f5f5;
  border: 1px solid #ddd;
  margin-right: 20px;
}

.button-group .confirm {
  background: #1890ff;
  color: white;
  border: none;
}
</style>
